import React from 'react';
import { useDispatch } from 'react-redux';

import { PdfIframe } from './PdfViewer.style';
import { isDealPdfLoading } from '../../store/actionCreators';
import type { DealSummaryPdfView } from '../../hook/useDealSummaryPdfRenderedTelemetry';
import { useDealSummaryPdfRenderedTelemetry } from '../../hook/useDealSummaryPdfRenderedTelemetry';
/**
 * Renders the deal-summary PDF: an empty state when no URL is available, otherwise the
 * PDF iframe with a loading overlay until it finishes loading.
 */
export const PdfView: React.FC<{ pdfUrl: string | undefined; view: DealSummaryPdfView }> = ({ pdfUrl, view }) => {
    const dispatch = useDispatch();
    const onPdfRendered = useDealSummaryPdfRenderedTelemetry(pdfUrl, view);

    return (
        <>
            <PdfIframe
                src={pdfUrl}
                title="PDF"
                onLoad={() => {
                    if (pdfUrl) {
                        dispatch(isDealPdfLoading(false));
                        onPdfRendered();
                    }
                }}
            />
        </>
    );
};
